import { formatMessageTimestamp, resolveMessageTimestamp } from './utils/messageTimestamp';

// Alignment comes from the parent flex container (user bubbles stack with `items-end`), so this
// only carries the time itself. `<time dateTime>` keeps the machine-readable value in the DOM.
function MessageTimestamp({ message }: { message: any }) {
  const date = resolveMessageTimestamp(message);

  if (!date) {
    return null;
  }

  return (
    <time className="text-xs text-gray-400" dateTime={date.toISOString()} data-testid="message-timestamp">
      {formatMessageTimestamp(date)}
    </time>
  );
}

export default MessageTimestamp;
